const state = {
    message: {
        visible: false,
        color: 'error',
        text: null,
        icon: 'close',
        multiline: false,
        timeout: 3000
    }
}

const mutations = {
    showSnackbar (state, payload) {
        state.message.text = payload.text
        state.message.multiline = (payload.text.length > 50)

        if (payload.multiline) {
            state.message.multiline = payload.multiline
        }

        state.message.color = payload.color ? payload.color : 'error'

        if (payload.timeout) {
            state.message.timeout = payload.timeout
        }

        state.message.visible = true
    },
    closeSnackbar (state) {
        state.message = {
            text: null,
            icon: 'close',
            timeout: 3000,
            color: 'error',
            visible: false,
            multiline: false
        }
    }
}

const actions = {}

const getters = {
    getSnackbar: state => state,
    getSnackbarState: state => state.message.visible
}

export default {
    state,
    mutations,
    getters,
    actions
}
